declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const trackLinkClick = (linkText: string, linkUrl: string) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'chatbot_link',
      linktext: linkText,
      linkurl: linkUrl,
    })
  }
}

export const trackInteraction = (clickText: string, clickClass: string) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Chatbot_interaction',
      click_text: clickText,
      click_class: clickClass,
    })
  }
}
